// Tiny logger that only emits to console in non-production builds, so end
// users don't see internal error noise in their devtools. Swap implementation
// for Sentry/LogRocket later without touching call-sites.
const isProduction = process.env.NODE_ENV === "production";

export const logger = {
  error: (...args) => {
    if (!isProduction) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
    // TODO: forward to Sentry/LogRocket in production builds.
  },
  warn: (...args) => {
    if (!isProduction) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (!isProduction) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
};

export default logger;
